module.exports = __webpack_public_path__ + "static/shadow-6b9908f4ac8abe72dde9dbd35a5fe88e.jpeg";